/** @format */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'homefield-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldCheckboxComponent {
  public readonly CheckboxVariants: Record<'medium' | 'large', string> = {
    medium: 'medium-variant hmf-body-m',
    large: 'large-variant hmf-body-l',
  };

  @Input()
  public label = '';

  @Input() fontSize: keyof typeof this.CheckboxVariants = 'medium';

  @Input()
  public isChecked = false;

  @Input()
  public isDisabled = false;

  @Input()
  public isError = false;

  @Input()
  public errorMessage = '';

  @Output()
  public readonly isCheckboxSelected = new EventEmitter<boolean>();

  isCheckboxSelectedState() {
    if (!this.isDisabled) {
      this.isChecked = !this.isChecked;
      this.isCheckboxSelected.emit(this.isChecked);
    }
  }
}
